import React, { FC } from 'react';
import { uniqueId } from 'lodash';

import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { createAppSyncLink, AUTH_TYPE } from 'aws-appsync';
import Auth from '@aws-amplify/auth';
import {
  defaultDataIdFromObject,
  IdGetterObj,
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory';

import { CommentsList } from '../../api';
import { AMPLIFY_CONFIG } from 'config/Amplify';

import introspectionQueryResultData from 'types/introspection-result';
import createOmitTypenameLink from '../links/omit_typename';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

const typenameLink = createOmitTypenameLink();

const appSyncLink = createAppSyncLink({
  url: AMPLIFY_CONFIG.aws_appsync_graphqlEndpoint,
  region: AMPLIFY_CONFIG.aws_appsync_region,
  auth: {
    type: AUTH_TYPE.AWS_IAM,
    credentials: Auth.currentCredentials,
  },
  complexObjectsCredentials: Auth.currentCredentials,
});

const link = ApolloLink.from([typenameLink, appSyncLink]);

const cache = new InMemoryCache({
  fragmentMatcher,
  dataIdFromObject: (object: IdGetterObj & CommentsList) => {
    switch (object.__typename) {
      case 'CommentsList':
        return object.id || `CommentsList:${uniqueId()}`;
      default:
        return defaultDataIdFromObject(object);
    }
  },
});

const client = new ApolloClient({
  link,
  cache,
  connectToDevTools: true,
});

const ApolloProtected: FC = ({ children }) => (
  <ApolloProvider client={client}>{children}</ApolloProvider>
);

export default ApolloProtected;
